module.exports = __webpack_public_path__ + "0007253427ca5fc2f72e71ac637ebc72.pdf";